import * as React from "react";
import EntityForm from "core/components/EntityForm";
import Topic from "panels/forum/entity/Topic";
import { TopicFeature } from "panels/forum/entity/TopicFeature";
import { Component } from "react";
import { ForumToaster } from "panels/forum/forumActions";
import { Button, Intent, Spinner } from "@blueprintjs/core";
import { BoxVariant, BoxView } from "common/views/box/Box.view";
import Label from "core/components/label/Label";
import labelProvider from "panels/forum/Forms.labels";
import { ButtonView } from "common/views/button/Button.view";
import ServiceRegistry from "core/util/ServiceRegistry";
import { topicFormWidget } from "./TopicComponentConfig";
import CheckBoxWidget from "common/form/widgets/CheckBoxWidget";
import { DatePickerWidget } from "common/form/widgets/date/DatePickerWidget";
import { IconNames } from "@blueprintjs/icons";
import styled from "styled-components";
import { RowsView } from "common/views/rows/Rows.view";
import autobind from "autobind-decorator";

const { Labels } = labelProvider;

export const FlexJustify = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;
export const Padding = styled.span`
	padding-left: 10px;
`;

export interface ITopicFeatureComponentProps {
    topic: Topic;
}

interface ITopicFeatureComponentState {
    expanded:boolean;
    /*enabled:boolean;
    expiresOn:Date;*/
    data:TopicFeature;
}

class TopicFeatureComponent extends Component<ITopicFeatureComponentProps,ITopicFeatureComponentState> {

    constructor(props: ITopicFeatureComponentProps){
        super(props);
        
        this.state = {
            expanded : false,
            data: null
        }
    }

    @autobind
    public async getData() {
        
        let res: any;
        let isPersisted = (this.props.topic.feature && this.props.topic.feature.id) ||
            (this.state.data && this.state.data.id);
        if(isPersisted)
            res = await ServiceRegistry.getQueryService().findOne(TopicFeature, {topicId:this.props.topic.id});
                
        if(isPersisted && res && res.data && res.data.entity) {
            this.setState({data:{...res.data.entity,topic:res.data.entity.topic.id},expanded:!this.state.expanded});
        } else {
            let tf = new TopicFeature();
            tf.topic = this.props.topic.id;
            tf.enabled=true;
            this.setState({data:tf,expanded:!this.state.expanded});
        }
    }

    public render() {
        let title = (
                <FlexJustify>
                    <Label k="topicfeature.save" v="Feature" />

                    <Button
                        icon={IconNames.CROSS}
                        minimal={true}
                        onClick={(e)=>this.setState({expanded:false})}
                    />
                </FlexJustify>
            );
        
        let feature = this.props.topic && this.props.topic.feature;
        let showFeatured = (feature && feature.enabled) || (this.state.data && this.state.data.id && this.state.data.enabled);       
        return (
            <React.Fragment>
                
                <Button onClick={() => this.getData()} icon={showFeatured?IconNames.STAR:undefined}>
                    {showFeatured ? (<Label k="topic.featured" v="Featured" />): (<Label k="topic.feature" v="Feature" />)}
                </Button>
                <Padding />
                {this.state.expanded && 
                    this.state.data &&
                    (<BoxView viewKey="feature.new" variant={BoxVariant.PANEL} title={title} >
                        
                        <Label k="topic.feature.enabled" v="Enabled" />
                        <CheckBoxWidget value={this.state.data.enabled} onChange={(v)=> this.setState({data:{...this.state.data,enabled:v}})} required={true} />  
                    
                        <Label k="topic.feature.expireson" v="Expires On" />
                        <DatePickerWidget value={this.state.data.endDate} onChange={(v)=> this.setState({data:{...this.state.data,endDate:v}})} required={true} 
                                maxDate={(()=> {
                                                                let d =new Date();
                                                                d.setFullYear(d.getFullYear() + 5);
                                                                return d;
                                                            })()}/>
                        <br/>
                        <Button onClick={this.save}>
                            <Label k="topic.feature.save" v="Submit" />
                        </Button>


                    </BoxView>)}
                    
            </React.Fragment>
        );

    }
    @autobind
    public save(){
        if(this.state.data && !this.state.data.endDate) {
            ForumToaster.show({
                intent: Intent.WARNING,
                message: "Please enter Expires On date!"
            });
            return;
        }
        const mutationService = ServiceRegistry.getMutationService();
        mutationService.save(this.state.data, TopicFeature).then((res) => {
            ForumToaster.show({
                intent: Intent.SUCCESS,
                message: "Post Featured!"
            });
            this.setState({data:{...this.state.data,id:res.entity.id},expanded:!this.state.expanded});
        }).catch((e) => {
            ForumToaster.show({
                intent: Intent.DANGER,
                message: "Error saving record!"
            });
        });
    }

}
export default TopicFeatureComponent;


// WEBPACK FOOTER //
// ./src/panels/forum/component/topic/TopicFeatureComponent.tsx